// extracted by mini-css-extract-plugin
export default {"span":"About_span__yj-rP","title":"About_title__pZpnC","goUp":"About_goUp__EA6QZ","anim-goUp":"About_anim-goUp__4DqeE"};